import { createUseStyles } from 'react-jss'

import { MQ, COLOR } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  line: {
    width: '100%',
    height: 20,
    [MQ.DESKTOP]: {
      height: 35,
    },
  },

  darkGreen: {
    background: COLOR.DARK_GREEN,
  },
  lightGreen: {
    background: COLOR.LIGHT_GREEN,
  },
  orange: {
    background: COLOR.ORANGE,
  },
  yellow: {
    background: COLOR.YELLOW,
  },
})
